export default __webpack_public_path__ + "static/media/case-study5.a0d6e01e.jpg";